import { Avtaar, Box, BoxProps, ColorOptions, Icon, Image, ImageProps, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import * as React from 'react'
import { useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { CustomRecyclerView } from '../CustomRecyclerView'
import { TOneSearchBar } from '../TOneSearchBar'

export interface DropDownData {
  text?: string
  imageUrl?: string
  id?: string
}

export interface DropdownProps {
  ID?: string
  data: Array<DropDownData>
  type?: number
  showSubTitle?: any
  setSelectedItem: any
  selectedValue: any
  convFeeComp: React.ReactNode
  amount?: string
}

export interface RefCalback {
  isEditable(): boolean
  focus(): void
}

const MIN_DATA_TO_SHOW = 10

const getImage = (item: any, type: any) => {
  if (item?.imageUrl) {
    return <Avtaar hide={!item?.imageUrl} source={item?.imageUrl ?? ''} type="medium" title={item?.text ?? ''} />
  } else {
    return (
      <Image
        {...styles.imageView}
        source={
          type === PAYMENT_MODE_SUBTYPES.WALLET
            ? require('../../assets/images/wallet.png')
            : require('../../assets/images/bank.png')
        }
      />
    )
  }
}

const ListItem = ({
  item,
  onPress,
  type,
  index,
  selectedItem,
  theme,
  showSubTitle,
  convFeeComp,
}: {
  item: DropDownData
  onPress: (item: DropDownData) => void
  type: number
  index: number
  selectedItem: any
  theme: any
  showSubTitle: any
  convFeeComp: React.ReactNode
}) => {
  const handlePress = () => onPress(item)
  const title = item?.text ?? ''

  return (
    <Box height={64}>
      <Box
        {...styles.container}
        onPress={handlePress}
        underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
        borderBottomColor={'SEPERATOR'}
        f={1}
        testID={`dropdownListItemId${index}`}>
        <>
          <Box f={1} alignItems="center" flexDirection={'row'}>
            {getImage(item, type)}
            <Spacer direction="horizontal" size={16} />
            <Box flexShrink={1}>
              <Text
                fontFamily="jioType-medium"
                fontSize={12}
                color={selectedItem ? (theme?.brandColor as ColorOptions) : (theme?.bodyTextColor as ColorOptions)}>
                {title}
              </Text>
              {selectedItem && showSubTitle !== '' && (
                <Text
                  fontFamily="jiotype-medium-italic"
                  fontSize={12}
                  color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
                  value={showSubTitle}
                />
              )}
              {convFeeComp && selectedItem && convFeeComp}
            </Box>
          </Box>
          {selectedItem && <Icon id="ROUND_TICK" color={theme?.brandColor as ColorOptions} size={24} />}
        </>
      </Box>
      <Box {...styles.separatorStyle(theme)} />
    </Box>
  )
}

export const TOneDropDownList: FC<DropdownProps> = ({
  data,
  type = PAYMENT_MODE_SUBTYPES.NB,
  showSubTitle,
  setSelectedItem: parentSetSelectedItem,
  selectedValue,
  convFeeComp,
  amount,
}: DropdownProps) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))

  const [searchText, setSearchText] = useState('')
  const [selectedItem, setSelectedItem] = useState(selectedValue)

  const onChangeText = (text: string) => {
    setSearchText(text)
  }

  const getListData = () => {
    const searchfn = (item: DropDownData) => {
      const search = searchText.toLowerCase()
      const text = item?.text?.toLowerCase() ?? ''
      return text.includes(search)
    }
    const listData = data.filter(searchfn)
    return listData
  }

  const onHandlePress = (item: DropDownData) => {
    parentSetSelectedItem(item?.id ?? '')
    setSelectedItem(item?.id ?? '')
  }

  const renderItem = ({ item, index }: { item: any; index: any }) => {
    return (
      <ListItem
        item={item}
        onPress={onHandlePress}
        index={index}
        type={type}
        selectedItem={selectedItem === item?.id}
        theme={theme}
        showSubTitle={showSubTitle}
        convFeeComp={convFeeComp}
      />
    )
  }

  const renderEmptyView = () => {
    return (
      <Box {...styles.emptyContainer}>
        <Text color={theme.bodyTextColor as ColorOptions} fontFamily="jioType-medium">
          Search not found
        </Text>
      </Box>
    )
  }

  return (
    <Box flex={1}>
      <TOneSearchBar
        isSearch={true}
        hide={data.length <= MIN_DATA_TO_SHOW}
        onChange={onChangeText}
        placeholder={type === PAYMENT_MODE_SUBTYPES.NB ? 'Search banks' : 'Search wallets'}
        value={searchText}
        autoFocus={false}
        theme={theme}
      />

      <Spacer size={8} />
      <CustomRecyclerView
        nativeID={'showListScrollBar'}
        data={getListData()}
        renderItem={renderItem}
        ListEmptyComponent={renderEmptyView}
      />
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    paddingVertical: 8,
    alignItems: 'center',
  } as BoxProps,
  boxContainer: {
    height: '90%',
  } as BoxProps,
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  imageView: {
    height: 32,
    width: 32,
  } as ImageProps,
  separatorStyle: (theme: any) =>
    ({ height: 1, backgroundColor: convertHexToRGBA(theme?.brandColor, 10) as ColorOptions } as BoxProps),
}
